/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Customize services
  Date: April 2020
**/


import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();

export const getConfigData = (payload) => {
  return API.get(`settings/config`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};